// Sub-flow-ul de scope „customer" al timeline-ului de activități.
// Extras din `NcrmActivityTimeline.vue` (fișier peste pragul de dimensiune) conform
// regulii din docs/engineering/modularity.md: bucata atinsă se mută într-un modul nou.
//
// Scope "record" (implicit) = doar activitățile ancorate pe recordul curent;
// "customer" = tot clusterul de client (company + persoane + lead-uri + deal-uri),
// agregat de backend prin `GET /ncrm/activity?scope=customer`.

export const ncrmActivityTimelineScopeComputed = {
  isCustomerScope() {
    return String(this.scope || "").trim().toLowerCase() === "customer";
  },
};

export const ncrmActivityTimelineScopeMethods = {
  // Construiește parametrii pentru `GET /ncrm/activity` (scope, context, paginare).
  // Mutat aici împreună cu restul logicii de scope; rulează în contextul componentei.
  buildFetchParams({ page = 1, limitOverride = null } = {}) {
    const params = {
      entityType: this.normalizedEntityType,
      entityId: this.normalizedEntityId,
      page,
    };

    const normalizedLimit = Number(limitOverride);
    if (Number.isFinite(normalizedLimit) && normalizedLimit > 0) {
      params.limit = Math.trunc(normalizedLimit);
    } else if (!this.isClientPrioritySortMode && this.maxItems > 0) {
      params.limit = this.maxItems;
    }

    if (this.applyCustomerScopeFetchParams(params)) return params;
    if (this.normalizedEntityContext) {
      params.entityContext = this.normalizedEntityContext;
    }
    if (this.normalizedOnboardingId) {
      params.onboardingId = this.normalizedOnboardingId;
    }
    if (this.includeOriginLeadActivity && this.normalizedEntityType === "deal") {
      params.includeOriginLead = true;
    }
    return params;
  },
  // Scope-ul customer agregă deja lead-urile/deal-urile clusterului în backend;
  // parametrii de context/origin nu se combină cu el (backend-ul întoarce 400).
  applyCustomerScopeFetchParams(params) {
    if (!this.isCustomerScope || this.normalizedEntityContext || this.normalizedOnboardingId) {
      return false;
    }
    params.scope = "customer";
    return true;
  },
  // În scope customer, activitățile ancorate pe alt record din cluster primesc un chip
  // de proveniență (ex. "Companie: X" pe pagina unui deal), ca sursa să fie evidentă.
  activityProvenanceLabel(activity) {
    if (!this.isCustomerScope) return "";
    const type = String(activity?.entity_type || "").trim().toLowerCase();
    const id = Number(activity?.entity_id);
    if (!type || !(id > 0)) return "";
    if (type === this.normalizedEntityType && id === this.normalizedEntityId) return "";
    const name = String(activity?.entity_name || "").trim() || `ID ${id}`;
    const key = `ncrm.activity.entityTypes.${type}`;
    const label = this.$t(key);
    return `${label === key ? type : label}: ${name}`;
  },
};
